module.exports = __webpack_public_path__ + "img/qrwi.fi-white-200x98.fc05f264.png";